import { h, resolveComponent } from 'vue'

import NewAdminLayout from "@/layouts/NewAdminLayout.vue";
import StoreNew from "@/views/cards/StoreNew.vue";

export default
{
  path: '/panel',
  name: 'Panel',
  props: {
    label: 'خانه',
  },
  meta: {
    requiresAuth: true,
  },
  component: NewAdminLayout,
  redirect: '/admin/dashboard',
  children: [
    // Rent And Reward
    // {
    //   "transactionState": "SUCCESS",
    //   "transactionTime": 1767711993405,
    //   "uuid": "0f0cfbe6-7e45-4753-a425-617df6418dad",
    //   "respObject": {
    //     "bank": "BSI",
    //     "accountNumber": "0221526333001",
    //     "ibanNumber": "IR910190000000221526333001",
    //     "firstName": "‌آذین‌ قیر صدر‌ا",
    //     "lastName": " ",
    //     "accountStatus": "ACTIVE",
    //     "nationalCode": "014012580130"
    //   }
    // }
    // {
    //   "transactionState": "SUCCESS",
    //   "transactionTime": 0,
    //   "uuid": "f1f44924-88ca-439d-8bbb-c8b85fdb6534",
    //   "respObject": {
    //     "ownerName": "جعفري غلامرضا",
    //     "accountNumber": "1000151617270",
    //     "bank": "PST",
    //     "iban": "IR930210000001000151617270"
    //   }
    // }
    {
      path: 'payment_able',
      name: 'NewPaymentAble',
      redirect: '/admin/payment_able/list',
      props: {
        label: 'پرداختنی ها',
      },
      component: {
        render() {
          return h(resolveComponent('router-view'))
        },
      },
      children: [
        {
          path: 'list',
          name: 'NewPaymentAbleList',
          props: {
            label: 'لیست پرداختنی ها',
          },
          component: () => import('@/views/paymentable/index.vue'),
        },
      ],
    },
    // {
    //   path: 'card',
    //   redirect: '/admin/card/list',
    //   props: {
    //     label: 'سفارش ها',
    //   },
    //   component: {
    //     render() {
    //       return h(resolveComponent('router-view'))
    //     },
    //   },
    //   children: [
    //     {
    //       path: 'new',
    //       name: 'StoreNew',
    //       props: {
    //         label: 'سفارش جدید',
    //       },
    //       component: StoreNew,
    //     },
    //   ],
    // }
  ],
}

